// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/Dashboard/CashRegisterStat/index.less
// module id = 1688
// module chunks = 0